const PRICE_DEFERRED = 'Price confirmed at checkout';

/** Format server minor-unit money; never substitute an amount or currency. */
export const formatMoney = (minorUnits: number | null | undefined, currency: string | null | undefined): string => {
  if (!Number.isSafeInteger(minorUnits) || typeof currency !== 'string' || !/^[a-z]{3}$/i.test(currency)) {
    return PRICE_DEFERRED;
  }
  try {
    const code = currency.toUpperCase();
    // HUF/TWD charge amounts can contain two decimals regardless of payout or
    // locale display conventions. These are charge, not payout, surfaces.
    const chargeFractionDigits = code === 'HUF' || code === 'TWD' ? 2 : undefined;
    const formatter = new Intl.NumberFormat('en-CA', {
      style: 'currency', currency: code, currencyDisplay: 'code',
      ...(chargeFractionDigits === undefined ? {} : { minimumFractionDigits: chargeFractionDigits, maximumFractionDigits: chargeFractionDigits })
    });
    // Stripe charge amounts retain two-decimal units for ISK/UGX despite their
    // zero-decimal display: https://docs.stripe.com/currencies#special-cases.
    const digits = code === 'ISK' || code === 'UGX' ? 2 : formatter.resolvedOptions().maximumFractionDigits;
    if (digits === undefined) return PRICE_DEFERRED;
    return formatter.format(minorUnits! / 10 ** digits);
  } catch {
    return PRICE_DEFERRED;
  }
};
